import script from "./RelatorioTemplateAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatorioTemplateAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./RelatorioTemplateAdministrar.vue?vue&type=style&index=0&id=3cc77e23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc77e23"]])

export default __exports__